import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const getEditDashboardById = (customer, id) => {
  return axios({
    url: `/config/${customer}/dashboard/${id}`,
    method: 'get'
  });
};
const useGetEditDashboardById = (customer, id) => {
  return useQuery(["get", "dashById", id], () => getEditDashboardById(customer, id), {
    enabled: !!customer && !!id
  });
};

export default useGetEditDashboardById;